module.exports = __webpack_public_path__ + "img/main_tnbox_service_03_2.8275c9c5.svg";